import { getProductInfo } from '@/shbdeployer/product';
import { formatDateTime } from '@/shbdeployer/format';
import { DOCUMENTATION_CATEGORIES, filterCategories, findArticle, getNeighbours, loadArticleContent } from '@/shbdeployer/docs/catalog';
import { buildDiagnosticsReport, collectBrowserInfo, copyToClipboard } from '../../services/diagnostics';

/**
 * Содержание встроенной документации: разделы, карточки статей и поиск.
 * Внешние службы не используются — поиск идёт по данным из сборки.
 */
export class DocumentationController {
  $onInit() {
    this.product = getProductInfo();
    this.query = '';
    this.categories = DOCUMENTATION_CATEGORIES;
    this.found = this.countArticles(this.categories);
  }

  countArticles(categories) {
    return categories.reduce((total, category) => total + category.articles.length, 0);
  }

  search() {
    this.categories = filterCategories(this.query);
    this.found = this.countArticles(this.categories);
  }

  reset() {
    this.query = '';
    this.search();
  }
}

/**
 * Страница статьи встроенной документации.
 *
 * Содержимое статьи собрано из docs/user/*.md на этапе сборки и входит
 * в поставку приложения, поэтому помечается доверенным: постороннего источника
 * у этой разметки нет.
 */
export class DocumentationArticleController {
  /* @ngInject */
  constructor($sce, $stateParams, $document) {
    this.$sce = $sce;
    this.$stateParams = $stateParams;
    this.$document = $document;
  }

  $onInit() {
    const id = this.$stateParams.articleId;
    this.article = findArticle(id);
    if (!this.article) {
      this.content = '';
      this.outline = [];
      this.previous = null;
      this.next = null;
      return;
    }

    const source = loadArticleContent(id);
    this.content = this.$sce.trustAsHtml(source.html);
    // В оглавление попадают подзаголовки: заголовок первого уровня совпадает
    // с названием статьи и уже показан в шапке страницы.
    this.outline = source.headings.filter((heading) => heading.level > 1 && heading.level < 4);

    const neighbours = getNeighbours(id);
    this.previous = neighbours.previous;
    this.next = neighbours.next;
  }

  scrollTo(id) {
    const element = this.$document[0].getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

export class AboutController {
  $onInit() {
    this.product = getProductInfo();
    this.buildDate = formatDateTime(this.product.buildDate);
    this.year = new Date().getFullYear();
  }
}

export class SupportController {
  /* @ngInject */
  constructor($async, Authentication, Notifications, ShbSystemService) {
    this.$async = $async;
    this.Authentication = Authentication;
    this.Notifications = Notifications;
    this.ShbSystemService = ShbSystemService;
    this.state = { copying: false, copied: false, report: '' };
  }

  $onInit() {
    this.product = getProductInfo();
    this.buildDate = formatDateTime(this.product.buildDate);
    this.isAdmin = this.Authentication.isAdmin();
    this.mailSubject = encodeURIComponent(`${this.product.name} ${this.product.version}: обращение в техническую поддержку`);
  }

  copyDiagnostics() {
    return this.$async(async () => {
      this.state.copying = true;
      this.state.copied = false;
      try {
        const status = await this.ShbSystemService.status().catch(() => null);
        const diagnostics = this.isAdmin ? await this.ShbSystemService.diagnostics().catch(() => null) : null;
        const report = buildDiagnosticsReport({ product: this.product, status, diagnostics, browser: collectBrowserInfo() });
        this.state.report = report;
        await copyToClipboard(report);
        this.state.copied = true;
      } catch (err) {
        this.Notifications.error('Ошибка', err, 'Не удалось скопировать диагностические сведения');
      } finally {
        this.state.copying = false;
      }
    });
  }
}
